import { Component } from '@angular/core';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';

@Component({
  selector: '[aditional-resources]',
  imports: [GlobalButtonComponent],
  templateUrl: './aditional-resources.component.html',
  styleUrl: './aditional-resources.component.scss',
})
export class AditionalResourcesComponent {
  cardButton1 = {
    buttonLabel: 'ADA Standards of Care 2026',
    buttonUrl: 'https://professional.diabetes.org/standards-of-care',
    openInNewTab: true,
    buttonIcon: 'right-icon',
    interstitial: true,
  };
  cardButton2 = {
    buttonLabel: 'ISPAD Guidelines 2024',
    buttonUrl:
      'https://www.ispad.org/resources/ispad-clinical-practice-consensus-guidelines/2024-cpcg.html',
    openInNewTab: true,
    buttonIcon: 'right-icon',
    interstitial: true,
  };
  cardButton3 = {
    buttonLabel: 'Breakthrough T1D Early Detection Guide',
    buttonUrl:
      'https://www.breakthrought1d.org/wp-content/uploads/2024/11/Early-Detection-Screening-Guidance-Tool-EN.pdf',
    openInNewTab: true,
    buttonIcon: 'right-icon',
    interstitial: true,
  };
}
